<template>
  <PopupBase :open="isOpen" @closePopup="close" :fullHeight="true">
    <div class="popup-content bg-white p-4 pt-0 rounded-custom">
      <div class="popup-header-wrapper pb-1">
        <div
          class="popup-header pt-4 d-flex justify-content-between align-items-start"
        >
          <h2 class="popup-title title-2">{{ title }}</h2>
          <button class="close-btn top-0 end-0 p-2" @click="close">
            <svg width="22" height="22">
              <use xlink:href="#___icon___close-x"></use>
            </svg>
          </button>
        </div>
        <div class="separator border-bottom my-2"></div>
      </div>

      <EcoActions
        :isCriteriaFloconVert="isCriteriaFloconVert"
        :isCriteriaCleVerte="isCriteriaCleVerte"
      />
      <RSEblock
        :isCriteriaFloconVert="isCriteriaFloconVert"
        :isCriteriaCleVerte="isCriteriaCleVerte"
      />
    </div>
  </PopupBase>
</template>

<script setup lang="ts">
import PopupBase from "@/vue/common/popupBase.vue";
import EcoActions from "@/vue/responsible-stay/components/EcoActions.vue";
import RSEblock from "@/vue/responsible-stay/components/RSEblock.vue";

defineProps({
  isOpen: Boolean,
  title: String,
  isCriteriaFloconVert: Boolean,
  isCriteriaCleVerte: Boolean,
});

const emit = defineEmits(["close"]);

const close = () => {
  emit("close");
};
</script>

<style scoped>
.close-btn {
  background: transparent;
  border: none;
  cursor: pointer;
}

.rounded-custom {
  border-radius: 1rem;
}

.popup-header-wrapper {
  padding-top: 0;
}

.popup-content {
  width: 100%;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1050;
  background-color: #fff;
}

@media (min-width: 768px) {
  .popup-content {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 90vh; /* optional */
    overflow-y: auto; /* scroll if content overflows */
  }
}
</style>
